import Axios from "axios";

export default function GetCounsellingSchedule(entrance_id){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'getCounsellingSchedule',
            entrance_id,
            
            //registration_id,
        }
    });
    return response;
}